// extracted by mini-css-extract-plugin
export default {"countdown":"style_countdown__yK8VY","warningText":"style_warningText__btWCJ","qrContainer":"style_qrContainer__gXzVH","buttonContainer":"style_buttonContainer__Klm11"};